<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">使用者群組</span>
        <div class="row">
            <div class="col-12">
                <form-input v-model="vm.Name" id="Name" label="名稱" type="text" required></form-input>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label>功能</label>
                    <label class="form-control" v-for="item in menus" :key="item.serial">
                        <input type="checkbox" v-model="vm.MenuSerial" :value="item.serial" />{{item.Title}}
                    </label>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'groupDetail',
        api: '/api/group/',
        data: { menus: [] },
        vm: { MenuSerial: [] },
        created: function () {
            window.menus = [];
            this.$parameter.menu().then((res) => { this.menus = res.data; });
        },
    });
</script>

<style>
</style>